export { default } from './formatMuiErrorMessage';


//////////////////
// WEBPACK FOOTER
// ../@mui/utils/esm/formatMuiErrorMessage/index.js
// module id = 66
// module chunks = 25